import { Routes } from '@angular/router';
import { BlackListRoute } from './black-list.route';
import { SiteManagmentRoute } from 'src/domains/site-managment/site-managment.route';
import { RouteSubComponent } from 'authorization';
import { RouteLazyComponent } from 'authorization';

export const blackListRouting: Routes = [
  {
    path: 'dashboard',
    loadComponent: () =>
      import(
        'src/domains/theme/app/component/full-layout/full-layout.component'
      ).then((c) => c.FullLayoutComponent),
    data: {
      breadcrumb: {
        skip: true,
      },
      title: '',
    },
    children: [
      {
        path: 'black_list',
        loadComponent: () =>
          import('./app/component/black-list/black-list.component').then(
            (c) => c.BlackListComponent,
          ),
        data: {
          breadcrumb: {
            skip: true,
          },
        },
      } as RouteSubComponent<typeof BlackListRoute.map.dashboard, 'black_list'>,
      {
        path: 'add_to_list',
        loadComponent: () =>
          import(
            './app/component/black-list-add/black-list-add.component'
          ).then((c) => c.BlackListAddComponent),
        data: {
          breadcrumb: {
            label: 'اضافه کردن',
            parent: ['لیست سیاه'],
            parentUrl: [SiteManagmentRoute.map.black_list.dashboard.black_list],
          },
          title: '',
        },
      } as RouteSubComponent<
        typeof BlackListRoute.map.dashboard,
        'add_to_list'
      >,
      {
        path: 'edit_list',
        loadComponent: () =>
          import(
            './app/component/black-list-edit/black-list-edit.component'
          ).then((c) => c.BlackListEditComponent),
        data: {
          breadcrumb: {
            label: 'ویرایش کردن',
            parent: ['لیست سیاه'],
            parentUrl: [SiteManagmentRoute.map.black_list.dashboard.black_list],
          },
          title: '',
        },
      } as RouteSubComponent<typeof BlackListRoute.map.dashboard, 'edit_list'>,
    ],
  } as RouteLazyComponent<typeof BlackListRoute.map, 'dashboard'>,
];
